import gql from 'graphql-tag'

export const TaskUpdateFragment = gql`
  fragment TaskUpdate on Task {
    name
    execConditions
    executionTimeout
    script
  }
`

export const TaskCreateFragment = gql`
  fragment TaskCreate on Task {
    _id
    environmentId
    createdAt
    status
    statusLog {
      timestamp
      status
      reason
    }
    lastExecutionTime
    lastExecutionLog {
      t
      m
    }
  }
`

export const TaskFragment = gql`
  fragment Task on Task {
    ...TaskCreate
    ...TaskUpdate
  }

  ${TaskCreateFragment}
  ${TaskUpdateFragment}
`
